import { useRootContents } from "../../aggregators/rootData"

export const useCustomColor = (id: string) => {
  const { colors } = useRootContents()
  return colors?.[id]
}
